module.exports = __webpack_public_path__ + "img/clock-snacks.c78d5cfd.svg";